// This enum must match the order of a smart contract enum
export var HapiInstruction;
(function (HapiInstruction) {
    HapiInstruction[HapiInstruction["CreateCommunity"] = 0] = "CreateCommunity";
    HapiInstruction[HapiInstruction["UpdateCommunity"] = 1] = "UpdateCommunity";
    HapiInstruction[HapiInstruction["CreateNetwork"] = 2] = "CreateNetwork";
    HapiInstruction[HapiInstruction["UpdateNetwork"] = 3] = "UpdateNetwork";
    HapiInstruction[HapiInstruction["CreateReporter"] = 4] = "CreateReporter";
    HapiInstruction[HapiInstruction["UpdateReporter"] = 5] = "UpdateReporter";
    HapiInstruction[HapiInstruction["CreateCase"] = 6] = "CreateCase";
    HapiInstruction[HapiInstruction["UpdateCase"] = 7] = "UpdateCase";
    HapiInstruction[HapiInstruction["CreateAddress"] = 8] = "CreateAddress";
    HapiInstruction[HapiInstruction["UpdateAddress"] = 9] = "UpdateAddress";
})(HapiInstruction || (HapiInstruction = {}));
// This enum must match the order of a smart contract enum
export var HapiAccountType;
(function (HapiAccountType) {
    HapiAccountType[HapiAccountType["Uninitialized"] = 0] = "Uninitialized";
    HapiAccountType[HapiAccountType["Community"] = 1] = "Community";
    HapiAccountType[HapiAccountType["Network"] = 2] = "Network";
    HapiAccountType[HapiAccountType["Reporter"] = 3] = "Reporter";
    HapiAccountType[HapiAccountType["Case"] = 4] = "Case";
    HapiAccountType[HapiAccountType["Address"] = 5] = "Address";
})(HapiAccountType || (HapiAccountType = {}));
// This enum must match the order of a smart contract enum
export var ReporterType;
(function (ReporterType) {
    ReporterType[ReporterType["Inactive"] = 0] = "Inactive";
    ReporterType[ReporterType["Tracer"] = 1] = "Tracer";
    ReporterType[ReporterType["Full"] = 2] = "Full";
    ReporterType[ReporterType["Authority"] = 3] = "Authority";
})(ReporterType || (ReporterType = {}));
// This enum must match the order of a smart contract enum
export var Category;
(function (Category) {
    // Tier 0
    /// Safe
    Category[Category["Safe"] = 0] = "Safe";
    // Tier 1 - Low risk
    /// Wallet service - custodial or mixed wallets
    Category[Category["WalletService"] = 1] = "WalletService";
    /// Merchant service
    Category[Category["MerchantService"] = 2] = "MerchantService";
    /// Mining pool
    Category[Category["MiningPool"] = 4] = "MiningPool";
    /// Exchange (Low Risk) - Exchange with high KYC standards
    Category[Category["LowRiskExchange"] = 8] = "LowRiskExchange";
    // Tier 2 - Medium risk
    /// Exchange (Medium Risk)
    Category[Category["MediumRiskExchange"] = 16] = "MediumRiskExchange";
    /// DeFi application
    Category[Category["DeFi"] = 32] = "DeFi";
    /// OTC Broker
    Category[Category["OTCBroker"] = 64] = "OTCBroker";
    /// Cryptocurrency ATM
    Category[Category["ATM"] = 128] = "ATM";
    /// Gambling
    Category[Category["Gambling"] = 256] = "Gambling";
    // Tier 3 - High risk
    /// Illicit organization
    Category[Category["IllicitOrganization"] = 512] = "IllicitOrganization";
    /// Mixer
    Category[Category["Mixer"] = 1024] = "Mixer";
    /// Darknet market or service
    Category[Category["DarknetService"] = 2048] = "DarknetService";
    /// Scam
    Category[Category["Scam"] = 4096] = "Scam";
    /// Ransomware
    Category[Category["Ransomware"] = 8192] = "Ransomware";
    /// Theft - stolen funds
    Category[Category["Theft"] = 16384] = "Theft";
    /// Counterfeit - fake assets that try to appear as something else
    Category[Category["Counterfeit"] = 32768] = "Counterfeit";
    // Tier 4 - Severe risk
    /// Terrorist financing
    Category[Category["TerroristFinancing"] = 65536] = "TerroristFinancing";
    /// Sanctions
    Category[Category["Sanctions"] = 131072] = "Sanctions";
    /// Child abuse and porn materials
    Category[Category["ChildAbuse"] = 262144] = "ChildAbuse";
})(Category || (Category = {}));
export const Categories = [
    Category.Safe,
    Category.WalletService,
    Category.MerchantService,
    Category.MiningPool,
    Category.LowRiskExchange,
    Category.MediumRiskExchange,
    Category.DeFi,
    Category.OTCBroker,
    Category.ATM,
    Category.Gambling,
    Category.IllicitOrganization,
    Category.Mixer,
    Category.DarknetService,
    Category.Scam,
    Category.Ransomware,
    Category.Theft,
    Category.Counterfeit,
    Category.TerroristFinancing,
    Category.Sanctions,
    Category.ChildAbuse,
];
export var CaseStatus;
(function (CaseStatus) {
    CaseStatus[CaseStatus["Open"] = 0] = "Open";
    CaseStatus[CaseStatus["Closed"] = 1] = "Closed";
})(CaseStatus || (CaseStatus = {}));
//# sourceMappingURL=enums.js.map